import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Check } from "lucide-react";
import { Button } from "@/Components/ui/button";
import PropTypes from 'prop-types';

const CopyCode = ({ code }) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset na 2 seconden
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className="flex items-center justify-between bg-white p-3 rounded-lg border mb-4">
            <label className="block text-lg font-inter font-bold text-ps-blue-dark">
                {t('profile.companyCode')}: {code}
            </label>
            <Button
                onClick={handleCopy}
                variant="ghost"
                size="sm"
                className={`transition-all duration-200 ${copied ? 'text-green-600' : 'text-gray-500 hover:text-ps-blue-dark'
                    }`}
                title={copied ? t('common.copied') || 'Copied!' : t('common.copyToClipboard') || 'Copy to clipboard'}
            >
                {copied ? (
                    <Check className="h-5 w-5" />
                ) : (
                    <Copy className="h-5 w-5" />
                )}
            </Button>
        </div>
    );
};

CopyCode.propTypes = {
    code: PropTypes.string
}

export default CopyCode;